export const isAuthenticated = () => {
    // Implement your authentication logic here
    return !!localStorage.getItem('auth.app.eventegration.com');
  };